import React, { useCallback } from 'react';
import { ReactNode } from 'react';
import { isCapacitor } from '@ui/utils/capacitor';
import { Browser } from '@capacitor/browser';
import { useZAlert } from '@ui/components/display/ZModal/use';
import { ZigArrowOutIcon } from '@ui/icons';

interface OpenLinkAlertConfig {
  title: string | ReactNode;
  description: string | ReactNode;
  okLabel: string | ReactNode;
  hideArrow?: boolean;
}

export function useOpenLink(alertConfig?: OpenLinkAlertConfig) {
  const showAlert = useZAlert();

  return useCallback(
    (url: string) => {
      if (isCapacitor) {
        Browser.open({ url });
      } else {
        const newWindow = window.open(url);

        if (
          alertConfig &&
          (!newWindow ||
            newWindow.closed ||
            typeof newWindow.closed === 'undefined')
        ) {
          showAlert({
            title: alertConfig.title,
            description: alertConfig.description,
            okAction: () => window.open(url),
            okLabel: (
              <>
                {alertConfig.okLabel}{' '}
                {alertConfig.hideArrow !== true && (
                  <ZigArrowOutIcon
                    width={'9px'}
                    height={'9px'}
                    style={{ marginBottom: '3px', marginLeft: '5px' }}
                  />
                )}
              </>
            ),
          });
        }
      }
    },
    [alertConfig, showAlert],
  );
}
